import { Link as ScrollLink } from 'react-scroll';
import { useLocation, Outlet } from 'react-router-dom';
// material
import { Box, Link, Container, Typography } from '@material-ui/core';
// components
import Label from '../../components/Label';
//
import MainNavbar from './MainNavbar';
import MainFooter from './MainFooter';


// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <>
      <MainNavbar />
      <Outlet />

      {!isHome ? (
        <MainFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default'
          }}
        >
          <Container maxWidth="lg">
            <ScrollLink to="move_top" spy smooth>
              <Label color="info" sx={{ ml: 1 }}>
                Sparkle Payroll
              </Label>
            </ScrollLink>

            <Typography variant="caption" component="p">
              © All rights reserved
              <br /> made by &nbsp;
              <Link href="https://www.sparkles.com.ph/">Sparkle Devteam</Link>
            </Typography>
          </Container>
        </Box>
      )}
    </>
  );
}
